import React from 'react';
import { Link } from "react-router-dom";
import { bool } from 'prop-types';
import { StyledMenu } from './Menu.styled';


const Menu = ({ open, ...props }) => {
  
  const isHidden = open ? true : false;
  const tabIndex = isHidden ? 0 : -1;

  return (
    <StyledMenu open={open} aria-hidden={!isHidden} {...props}>
      <Link to="/about" tabIndex={tabIndex}>
        <span aria-hidden="true">💁🏻‍♂️</span>
        About us
      </Link>
      <Link to="/pricing" tabIndex={tabIndex}>
        <span aria-hidden="true">💸</span>
        Pricing
        </Link>
      <a href="/contact" tabIndex={tabIndex}>
        <span aria-hidden="true">📩</span>
        Contact
        </a>
    </StyledMenu>
  )
}

Menu.propTypes = {
  open: bool.isRequired,
}

export default Menu;
